import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import find from 'ramda/src/find';
import isEmpty from 'ramda/src/isEmpty';
import propEq from 'ramda/src/propEq';
import Avatar from '@components/@core/Avatar';
import EditDropdown from '@components/EditDropdown';
import HDropdown from '@components/HoverDropdown';
import { CertificationReportMenu } from '~/services/config';

const EmployeesReport = ({ role, data, onClick }) => {
    const navigate = useNavigate();
    const users = useSelector((state) => state.app.users);
    return (
        <div className="employees-report-list" data-cy="employeesList">
            <div className="d-flex border-bottom py-3 desktop-screen">
                <div className="d-flex-6 d-flex-ssm-6 dsl-m12 text-400" data-cy="employeeCol">
                    Employee
                </div>
                <div data-cy="openCol" className="d-flex-1 d-flex-ssm-3 dsl-m12 text-400 ms-3 ms-md-1 text-end">
                    Open
                </div>
                <div data-cy="certificationCol" className="d-flex-8 dsl-m12 px-3 text-400 ms-1">
                    Certifications
                </div>
                <div data-cy="completedCol" className="d-flex-2 dsl-m12 text-400 ms-3 ms-md-0">
                    Completed
                </div>
                <div data-cy="completedCertificationCol" className="d-flex-8 dsl-m12 px-0 px-md-0 text-400">
                    Certifications
                </div>
                <div className="d-flex-1 desktop-screen" />
            </div>
            {isEmpty(data) ? (
                <div className="d-h-center pt-4" data-cy="no-certification-assigned">
                    <span className="dsl-m16">No certifications Assigned</span>
                </div>
            ) : (
                data?.map((user) => {
                    const employee = find(propEq('id', user.id), users);
                    const name = `${user?.profile?.first_name}  ${user?.profile?.last_name}`;
                    const openCerts = user?.stats?.open_certifications?.map((e) => {
                        const { id, title } = e;
                        return {
                            id,
                            title,
                            program: e,
                        };
                    });

                    const completedCerts = user?.stats?.completed_certifications?.map((e) => {
                        const { id, title } = e;
                        return {
                            id,
                            title,
                            program: e,
                        };
                    });
                    const certs = user?.stats?.open_certifications[0];
                    let editOptions = [];
                    if (openCerts?.length === 0 && completedCerts?.length === 0) {
                        editOptions = CertificationReportMenu[role].filter((option) => option === 'Assign Certification');
                    } else {
                        editOptions = CertificationReportMenu[role];
                    }
                    return (
                        <div data-cy="employeeRowItem" className="cert-list d-flex ssm-column ai-center border-bottom py-0 py-md-4" key={user.id}>
                            <div
                                data-cy="avatar"
                                className="d-flex ai-center jc-between d-flex-6 cursor-pointer w-100 my-2 my-sm-0"
                                onClick={() => onClick('view certification', certs, null, 'employees')}
                            >
                                <div className="d-flex ai-center">
                                    <Avatar name={name} url={employee?.avatar} onToggle={() => navigate(`/library/record-employee-info/${user.id}`)} />
                                    <span data-cy="employeeName" className="dsl-b14 ms-3 text-400 text-break">
                                        {name}
                                    </span>
                                </div>
                                {editOptions.length !== 0 && (
                                    <EditDropdown className="mobile-screen" options={editOptions} onChange={(e) => onClick(e, user.stats.open_certifications, user, 'employees')} />
                                )}
                            </div>
                            <div data-cy="employeerowOpenVal" className="d-flex-1 dsl-b14 text-end ssm-left text-400 w-100">
                                <label className="dsl-b14 mobile-screen w-30">Open</label>
                                {user?.stats?.open}
                            </div>
                            <div data-cy="certificationStat" className="d-flex d-flex-8 dsl-b14 text-400 w-100">
                                <label className="dsl-b14 mobile-screen w-30 pe-0 ssp-r-3">Certification</label>
                                {isEmpty(openCerts) ? (
                                    <span className="dsl-b14 ms-2 ssm-l-0 text-400">Nothing open</span>
                                ) : (
                                    <HDropdown
                                        className="p-0 ps-2 "
                                        data={openCerts}
                                        getValue={(e) => e.title}
                                        onClick={(data) => onClick('view certification', data, null, 'employees')}
                                        width="100%"
                                    />
                                )}
                            </div>
                            <div data-cy="completedStat" className="d-flex-2 dsl-b14 text-end ssm-left text-400 w-100">
                                <label className="dsl-b14 mobile-screen w-30">Completed</label>
                                {user?.stats?.completed}
                            </div>
                            <div data-cy="completedCertificationStat" className="d-flex d-flex-8 dsl-b14 w-100">
                                <label className="dsl-b14 mobile-screen w-30">Certification</label>
                                {isEmpty(completedCerts) ? (
                                    <div className="dsl-b14 ms-2 ssm-l-0 ps-1 ssp-l-0 text-400">Nothing completed</div>
                                ) : (
                                    <HDropdown
                                        className="p-0 ps-2"
                                        data={completedCerts}
                                        getValue={(e) => e.title}
                                        onClick={(data) => onClick('view certification', data, null, 'employees')}
                                        width="100%"
                                    />
                                )}
                            </div>
                            <div data-cy="threeDotMenu" className="d-flex-1 desktop-screen">
                                {editOptions.length !== 0 && <EditDropdown options={editOptions} onChange={(e) => onClick(e, user.stats.open_certifications, user, 'employees')} />}
                            </div>
                        </div>
                    );
                })
            )}
        </div>
    );
};

EmployeesReport.propTypes = {
    admin: PropTypes.bool,
    data: PropTypes.array,
    onClick: PropTypes.func,
};

EmployeesReport.defaultProps = {
    admin: false,
    data: [],
    onClick: () => {},
};

export default EmployeesReport;
